/**
 * client/src/hooks/useGenerationLimit.ts
 *
 * React Query hook that fetches the authenticated user's daily AI-generation
 * usage from GET /api/generation-limit.
 *
 * Shape returned by the server (matches GuardResult from subscriptionGuard.ts):
 *   { allowed, used, limit, remaining, planCode }
 *   limit / remaining = null for unlimited tiers (PRO, ENTERPRISE).
 */

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";

export interface GenerationLimitStatus {
  allowed: boolean;
  used: number;
  limit: number | null;      // null = unlimited
  remaining: number | null;  // null = unlimited
  planCode: string;
}

export function useGenerationLimit() {
  const { user } = useAuth();

  return useQuery<GenerationLimitStatus>({
    queryKey: ["/api/generation-limit"],
    enabled: !!user,
    staleTime: 30_000,     // re-fetch after 30 s
    refetchOnWindowFocus: true,
  });
}
